module.exports = __webpack_public_path__ + "img/ic_document_2.37fa9f97.svg";